const GuidLike =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isValidRouteDocumentId(value: string | undefined | null): boolean {
  if (value === undefined || value === null) {
    return false;
  }
  const t = String(value).trim();
  if (!t) {
    return false;
  }
  if (t === 'undefined' || t === 'null') {
    return false;
  }
  return GuidLike.test(t);
}

export function hasInvalidRouteIdSegment(path: string): boolean {
  const pathOnly = path.split('?')[0];
  const segments = pathOnly.split('/').filter(Boolean);
  return segments.some((s) => s === 'undefined' || s === 'null');
}
